export const RouteDialogMixin = {
  data() {
    return {
      routePath: null
    };
  },

  computed: {
    routeActive() {
      if (!this.routePath) {
        return false;
      }

      const {matched} = this.$route;
      for (const route of matched) {
        if (route.path === this.routePath) {
          return true;
        }
      }
      return false;
    }
  },

  watch: {
    routeActive(routeActive) {
      if (routeActive) {
        this.show();
      } else {
        this.hide();
      }
    }
  },

  mounted() {
    // Trigger watcher.
    let routeActive = this.$options.watch.routeActive;
    if (Array.isArray(routeActive)) { // If there is also a watcher in the component.
      routeActive = routeActive[0];
    }
    routeActive.call(this, this.routeActive);
  }
};

export default RouteDialogMixin;
